import React, { FC, useState } from 'react'
import { Trans } from '@ui/i18n/trans'

import { IconButton, IconButtonProps } from '@ui/buttons/icon-button'
import { DownloadIcon } from '@ui/icons/material/Download'

import { Tooltip } from '@ui/tooltip/tooltip'
import { useSettings } from '@ui/settings/use-settings'

import { useAuth } from '@common/auth/use-auth'
import { Track } from '@player/types'

import { downloadFileFromUrl } from '@ui/utils/files/download-file-from-url'
import clsx from 'clsx';

export interface DownloadButtonProps {
    track: Track
    className?: IconButtonProps['className'],
    size?: IconButtonProps['size']
}

export const DownloadButton: FC<DownloadButtonProps> = ({ track, className = 'h-24 w-24', ...props }) => {
    const { player, base_url } = useSettings()
    const { hasPermission } = useAuth()

    const [pressed, setPressed] = useState<boolean>(false)

    if (
        !player?.enable_download ||
        !track ||
        !hasPermission('music.download')
    ) {
        return null
    }

    return (
        <Tooltip delay={0} label={<Trans message="Download" />}>
            <IconButton
                className={clsx(className, {
                    '!opacity-30': pressed || track?.activity?.downloaded
                })}
                onClick={(event) => {
                    event.stopPropagation()
                    event.preventDefault()

                    setPressed(true)
                    downloadFileFromUrl(`${base_url}/api/v1/tracks/${track.id}/download`)
                }}
                {...props}
            >
                <DownloadIcon className={className} />
            </IconButton>
        </Tooltip>
    )
}
